import AddCollegeScholraship from "../../Components/Modals/AddCollegeScholraship";
import Table from "../../Components/Table";
import { deleteCollegeScholarshipById, getAllCollegeScholarships } from "../../Services/CollegeService";

const CollegeScholarship = () => {
    const columns = [
        {
            label: "College Name",
            value: "college_name"
        },
        {
            label: "Scholarship Name",
            value: "scholarship_name"
        },
        {
            label: "Eligibility_Criteria",
            value: "eligibility_criteria"
        },
        {
            label: "Deadline",
            value: "deadline"
        },
        {
            label: "Award",
            value: "award"
        },
        {
            label: "Year",
            value: "year"
        },
    ];

    const renderAddModal = (openAddModal, setOpenAddModal) => {
        return (
            <AddCollegeScholraship data={openAddModal} onClose={() => setOpenAddModal()} onCloseWithApi={() => setOpenAddModal(true)} />
        )
    };

    return (
        <Table
            api={getAllCollegeScholarships}
            columns={columns}
            title={"College Scholarships"}
            addModal={renderAddModal}
            showAddButton={true}
            showExportButton={true}
            deleteApi={deleteCollegeScholarshipById}
        />
    );
}

export default CollegeScholarship;